import React from "react"
import OwnerLabel from "@/components/activities/owner_label"
import ActivityBase from "@/components/activities/base"
import i18n from "@/i18n"
import Changes from "@/components/activities/changes"

interface ContactUpdatedProps {
  activity: any
  className?: string
}

const ContactUpdated = ({ activity, className }: ContactUpdatedProps) => {
  const LABELS = {
    firstName: i18n.t("app.activities.customer.field_labels.first_name"),
    lastName: i18n.t("app.activities.customer.field_labels.last_name"),
    email: i18n.t("app.activities.customer.field_labels.email"),
    phone: i18n.t("app.activities.customer.field_labels.phone"),
  }

  const formatters = {}

  const changes = activity.parameters.changes

  return (
    <ActivityBase
      data-testid="panel-activity-customer-updated"
      activityKey={activity.key}
      text={
        <>
          <div>
            {i18n.react("app.activities.customer.contact_updated.description", {
              owner: <OwnerLabel owner={activity.owner} />,
            })}
            <Changes changes={changes} labels={LABELS} formatters={formatters} />
          </div>
        </>
      }
      createdAt={activity.createdAt}
      className={className}
    />
  )
}

export default ContactUpdated
